import React, { useEffect } from 'react';
import Loader from '../../components/loader/Loader';
import { auth } from '../../js/GRP';

const GrpView = () => {
  
    useEffect(() => {
        auth.authorize();
    });

    return (
        <div className="b-grp-view">
             <Loader loading />
        </div>
    );
};

export default GrpView;
